var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.4 105.4C245.9 92.8999 266.2 92.8999 278.7 105.4L470.7 297.4C483.2 309.9 483.2 330.2 470.7 342.7C458.2 355.2 437.9 355.2 425.4 342.7L256 173.3L86.6 342.6C74.1 355.1 53.8 355.1 41.3 342.6C28.8 330.1 28.8 309.8 41.3 297.3L233.3 105.3L233.4 105.4Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronSolid);
export default __webpack_public_path__ + "static/media/chevron-solid.824d5a510fa67a98ca1ca44256324d56.svg";
export { ForwardRef as ReactComponent };